<template>
  <div v-if="!getDeviceType()" class="loginPage">
    <div class="loginColumn">
      <img class="loginLogo" src="@/assets/searchLogo.svg" />
      <img class="loginImage" src="@/assets/loginIcon.png" />
      <img class="loginLogoText" src="@/assets/CourseLnk.png" />
    </div>
    <div class="loginColumn">
      <form @submit.prevent="signup" class="loginForm">
        <p class="loginTitle">Join now</p>
        <div class="user-input-wrp">
          <input
            v-model="email"
            type="text"
            name="email"
            required
            placeholder=" "
            class="inputText"
          />
          <span class="floating-label">University email*</span>
        </div>

        <div class="signUpNames">
          <div
            class="user-input-wrp user-input-wrpSmall"
            style="margin-right: 10px"
          >
            <input
              v-model="firstName"
              type="text"
              name="name"
              required
              placeholder=" "
              class="inputText"
            />
            <span class="floating-label">First name*</span>
          </div>
          <div class="user-input-wrp user-input-wrpSmall">
            <input
              v-model="lastName"
              type="text"
              name="name"
              required
              placeholder=" "
              class="inputText"
            />
            <span class="floating-label">Last name*</span>
          </div>
        </div>

        <div class="user-input-wrp">
          <input
            v-model="password"
            type="password"
            name="psw"
            required
            placeholder=" "
            class="inputText"
          />
          <span class="floating-label">Create password*</span>
        </div>

        <!--div class="user-input-wrp">
          <input
            v-model="referralEmail"
            type="password"
            name="referral"
            class="inputText"
          />
          <span class="floating-label">Referral (optional)</span>
        </div-->

        <p v-if="feedback" class="feedback">{{ feedback }}</p>

        <div class="endForm">
          <button type="submit" class="joinButtonSmall">Create account</button>
        </div>
        <p class="forgotPassword">
          By signing up you agree to our
          <router-link :to="{ name: 'Terms' }" target="_blank">
            Terms
          </router-link>
          and
          <router-link :to="{ name: 'Privacy' }" target="_blank">
            Privacy Policy
          </router-link>
        </p>
        <div class="loginSignupDivider"></div>
        <div class="signupBox">
          <router-link class="joinButtonSmall toSignup" :to="{ name: 'Login' }"
            >Go to log in</router-link
          >
        </div>
      </form>
    </div>
    <div class="bottomNav">
      <p class="landingButtonHoverless">CourseLnk © 2021</p>
      <router-link
        class="landingButton"
        :to="{
          name: 'Landingpage',
        }"
        >About</router-link
      >
      <router-link
        class="landingButton"
        :to="{ name: 'Terms' }"
        target="_blank"
      >
        Terms and Conditions
      </router-link>
      <router-link
        class="landingButton"
        :to="{ name: 'Privacy' }"
        target="_blank"
      >
        Privacy Policy
      </router-link>
      <router-link class="landingButton" :to="{ name: 'Ambassadors' }">
        Join the team
      </router-link>
    </div>
    <div class="bottomNavSmall">
      <p class="landingButtonHoverless">CourseLnk © 2021</p>
      <div class="bottomColumn">
        <router-link
          class="landingButton"
          :to="{
            name: 'Landingpage',
          }"
          >About</router-link
        >
        <router-link class="landingButton" :to="{ name: 'Ambassadors' }">
          Join the team
        </router-link>
      </div>
      <div class="bottomColumn">
        <router-link
          class="landingButton"
          :to="{ name: 'Terms' }"
          target="_blank"
        >
          Terms and Conditions
        </router-link>
        <router-link
          class="landingButton"
          :to="{ name: 'Privacy' }"
          target="_blank"
        >
          Privacy Policy
        </router-link>
      </div>
    </div>
  </div>
  <div v-else class="loginPage">
    <div class="loginColumn"></div>
    <div class="loginColumn">
      <div @submit.prevent="login" class="loginForm formOnPhone">
        <img class="loginLogo" src="@/assets/searchLogo.svg" />
        <img class="loginLogoTextPhone" src="@/assets/CourseLnk.png" />
        <p class="loginTitle">Welcome to your online campus!</p>
        <form
          method="get"
          action="https://apps.apple.com/ca/app/courselnk/id1545799969"
        >
          <img src="../../assets/downloadOnAppStore.png" />
        </form>
        <p class="phoneText">Or access courselnk.com on a computer</p>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "@/firebase";
import db from "@/db";
export default {
  name: "Signup",
  data: () => ({
    schools: [],
    email: null,
    firstName: null,
    lastName: null,
    password: null,
    referralEmail: null,
    university: 0,
    feedback: null,
    showConfirm: false,
    addReferral: false,
    numReferrals: 0,
  }),
  mounted() {
    this.getSchools();
    this.checkForReferralLink();
    this.getIOS();
    //this.getUidFromEmail(); HAD ERROR MESSAGE FROM THIS
  },

  methods: {
    getDeviceType() {
      const ua = navigator.userAgent;
      if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
        return true;
      }
      if (
        /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
          ua
        )
      ) {
        return true;
      }
      return false;
    },
    addFirstNameKeyWords(name) {
      var letters = [];
      var firstNameKeywords = [];
      var userName = name.split(" ");
      for (var i = 0; i < userName.length; i++) {
        var word = userName[i];
        for (var l = 1; l < word.length + 1; l++) {
          firstNameKeywords.push(word.substring(0, l).toLowerCase());
        }
      }
      for (var k = 1; k < name.length + 1; k++) {
        letters.push(name.substring(0, k).toLowerCase());
      }
      letters = firstNameKeywords.concat(letters);
      letters = letters.filter((v, i, a) => a.indexOf(v) === i);
      return letters;
    },
    addLastNameKeyWords(name) {
      var letters = [];
      var lastNameKeywords = [];
      var userName = name.split(" ");
      for (var i = 0; i < userName.length; i++) {
        var word = userName[i];
        for (var l = 1; l < word.length + 1; l++) {
          lastNameKeywords.push(word.substring(0, l).toLowerCase());
        }
      }
      for (var k = 1; k < name.length + 1; k++) {
        letters.push(name.substring(0, k).toLowerCase());
      }
      letters = lastNameKeywords.concat(letters);
      letters = letters.filter((v, i, a) => a.indexOf(v) === i);
      return letters;
    },
    iOS() {
      return (
        [
          "iPad Simulator",
          "iPhone Simulator",
          "iPod Simulator",
          "iPad",
          "iPhone",
          "iPod",
        ].includes(navigator.platform) ||
        // iPad on iOS 13 detection
        (navigator.userAgent.includes("Mac") && "ontouchend" in document)
      );
    },

    getIOS() {
      if (this.iOS()) {
        window.location.replace("https://courselnk.page.link/share");
      }
    },

    //Gets list of all schools
    async getSchools() {
      var tempSchools = [];
      await db
        .collection("schools")
        .get()
        .then(function(querySnapshot) {
          querySnapshot.forEach(function(doc) {
            tempSchools.push(doc);
          });
        });
      this.schools = tempSchools;
    },

    async checkForReferralLink() {
      let uid = this.$route.params.uid;
      if (uid) {
        var getUserFromUid = firebase
          .functions()
          .httpsCallable("getUserFromUid");
        const data = await getUserFromUid(uid);
        //console.log(data.data.uid);
        await db
          .collection("ambassadorInfo")
          .doc(data.data.uid)
          .get()
          .then((doc) => {
            if (doc.exists) {
              this.$store.commit("user/setReferral", doc.data().referralCode);
            } else {
              this.$store.commit(
                "user/setReferral",
                JSON.parse(JSON.stringify(data)).data.email
              );
            }
          });

        /*this.$store.commit(
          "user/setReferral",
          JSON.parse(JSON.stringify(data)).data.email
        );*/
      }
    },

    async getUidFromEmail() {
      var getUserFromEmail = firebase
        .functions()
        .httpsCallable("getUserFromEmail");
      const data = await getUserFromEmail(this.referralEmail);
      return JSON.parse(JSON.stringify(data)).data.uid;
    },

    async createUser() {
      this.email = this.email.toLowerCase().replace(/\s/g, "");
      firebase
        .auth()
        .createUserWithEmailAndPassword(this.email, this.password)
        .then((cred) => {
          db.collection("users")
            .doc(cred.user.uid)
            .set({
              created_at: Date.now(),
              firstName: this.firstName.trim(),
              lastName: this.lastName.trim(),
              school_id: this.university,
              firstNameKeywords: this.addFirstNameKeyWords(
                this.firstName.trim()
              ),
              lastNameKeywords: this.addLastNameKeyWords(this.lastName.trim()),
              courses: [],
              faculties: [],
              groups: [],
              directMessages: [],
              images: [],
              id: cred.user.uid,
              numReferrals: this.numReferrals,
              progressBar: {
                interests: false,
                bio: false,
                photos: false,
                joinGroup: false,
                addFriend: false,
                profileImage: false,
              },
              profileImage:
                "https://firebasestorage.googleapis.com/v0/b/courselnk.appspot.com/o/defaultUserImage%2FdefaultUserImage.jpeg?alt=media&token=d0140e78-d883-4a02-9827-82a89596eb6c",
            });

          db.collection("schools")
            .doc(this.university)
            .update({
              userCount: firebase.firestore.FieldValue.increment(1),
            });
          this.$router.push({ name: "SetUp" });
        })
        .catch((err) => {
          this.feedback = err.message;
        });
    },

    validateEmail(email) {
      var re = /\S+@\S+\.\S+/;
      return re.test(email);
    },

    //Signs the user up
    signup() {
      if (this.firstName && this.lastName && this.email && this.password) {
        if (
          !this.validateEmail(this.email) ||
          this.email.endsWith("@gmail.com") ||
          this.email.endsWith("@yahoo.com") ||
          this.email.endsWith("@yahoo.ca") ||
          this.email.endsWith("@hotmail.com")
        ) {
          this.feedback = "Please enter a valid university email";
          return;
        }

        this.getSchoolId();

        if (this.university == "") {
          this.feedback = "Your university has not been added yet";
          return;
        }
        this.createUser();
      } else {
        this.feedback = "You must enter all fields";
      }
    },

    getSchoolId() {
      if (this.email.endsWith("@trentu.ca")) {
        this.university = "ZP4XckEioy7tqvjebFYa";
        return;
      } else if (this.email.endsWith("@uwo.ca")) {
        this.university = "pOFdIKe2KVcQ8IbEl6sw";
        return;
      } else if (this.email.endsWith("@mail.mcgill.ca")) {
        this.university = "5Uo24jSg4nGg3sVOzeec";
        return;
      } else if (this.email.endsWith("carleton.ca")) {
        this.university = "72oEfKqwwa3I4dwWOC6E";
        return;
      } else if (this.email.endsWith("ualberta.ca")) {
        this.university = "U7bTpI3Qb7ltzSiFLT5V";
        return;
      } else if (this.email.endsWith("queensu.ca")) {
        this.university = "ZYEtBmUsC1gxEgCXcqrO";
        return;
      } else if (this.email.endsWith("uottawa.ca")) {
        this.university = "dWQpMtihliZhnC8BhEvk";
        return;
      } else if (this.email.endsWith("ubc.ca")) {
        this.university = "Lk6U5xlHtZEeKvJhfGmD";
        return;
      } else if (this.email.endsWith("utoronto.ca")) {
        this.university = "6StICCPUC4vEQD8LzAto";
        return;
      } else if (
        this.email.endsWith("laurier.ca") ||
        this.email.endsWith("wlu.ca")
      ) {
        this.university = "MKt8CfO89pRZFs4tSOhr";
        return;
      } else if (this.email.endsWith("uwaterloo.ca")) {
        this.university = "6DcIR8ElGYcwQjdExlCP";
        return;
      } else if (this.email.endsWith("guelph.ca")) {
        this.university = "1lv8EkSNVu0XRWbV5bfJ";
        return;
      } else if (this.email.endsWith("dal.ca")) {
        this.university = "N24T3p9u1bUGBtwl0Xe2";
        return;
      } else if (this.email.endsWith("brocku.ca")) {
        this.university = "Pyilf9RWqlUdr1RQ07bN";
        return;
      } else if (this.email.endsWith("mun.ca")) {
        this.university = "oToAMJsO2SGmAt2PnBqU";
        return;
      } else if (this.email.endsWith("concordia.ca")) {
        this.university = "t4o2m0THPhr08DOs0PuM";
        return;
      } else if (this.email.endsWith("depaul.edu")) {
        this.university = "qHPA943HIMJwWatqUdhT";
        return;
      } else if (this.email.endsWith("illinois.edu")) {
        this.university = "AHFxac59JNf63I3PlelQ";
        return;
      } else if (this.email.endsWith("luc.edu")) {
        this.university = "nogvPnt2CW8nbCyg95QE";
        return;
      } else if (this.email.endsWith("mcmaster.ca")) {
        this.university = "ynN6QCUHtxgptPBDq7tQ";
        return;
      } else if (this.email.endsWith("northwestern.edu")) {
        this.university = "PWTuJEmiidq6wVfUQbuU";
        return;
      } else if (this.email.endsWith("ryerson.ca")) {
        this.university = "6YhBHH63lQgkiqbdhlhV";
        return;
      } else if (this.email.endsWith("yorku.ca")) {
        this.university = "y6albITslsz1y9tYQKII";
        return;
      } else if (this.email.endsWith("uchicago.edu")) {
        this.university = "JRZfRwnC7dSVugJc5LXs";
        return;
      } else if (this.email.endsWith("uwindsor.ca")) {
        this.university = "nax1P5P1uZFammjYu9do";
        return;
      } else if (this.email.endsWith("umanitoba.ca")) {
        this.university = "WulVFjygvvyiw9PTobRn";
        return;
      } else if (this.email.endsWith("usask.ca")) {
        this.university = "IsWKoa56iflltF2FPAk5";
        return;
      } else if (this.email.endsWith("sfu.ca")) {
        this.university = "oklJp59dkd4SNFp91NoL";
        return;
      } else if (this.email.endsWith("uregina.ca")) {
        this.university = "rJA9BVDGaOHDJ75Uy62k";
        return;
      } else if (this.email.endsWith("uoit.ca")) {
        this.university = "ZHofaGQR0f9EEhZ4z97h";
        return;
      } else if (this.email.endsWith("uleth.ca")) {
        this.university = "tuIRZeHjxXzVrIBmKnun";
        return;
      } else if (this.email.endsWith("tru.ca")) {
        this.university = "rj4m5QRYxNNguSHFenBA";
        return;
      } else if (this.email.endsWith("mtroyal.ca")) {
        this.university = "VCzObj1LQQDaYj9qOjRW";
        return;
      } else if (this.email.endsWith("macewan.ca")) {
        this.university = "lqc8TQQ4pXAdLkihNNgY";
        return;
      } else if (this.email.endsWith("uvic.ca")) {
        this.university = "YwqIFH30daZaZbt6KSji";
        return;
      } else if (this.email.endsWith("kpu.ca")) {
        this.university = "TDqUddIMViclfPRpkPuG";
        return;
      } else if (this.email.endsWith("ucalgary.ca")) {
        this.university = "3xgISRcVVqKT80Q56Te1";
        return;
      }

      this.university = "";
    },
  },
};
</script>

<style scoped src="@/styles/components/auth/Login.css"></style>
